import env from '../config'

export const getApiRoot = () => {
    return env.apiRoot || window.location.origin + '/api/v1/'
}